import { useEffect } from 'react';
import { noticeError } from '../components/newrelic/requests';

export function useRenderAlerts(id: string) {
  useEffect(() => {
    function checkForChildNodes() {
      const homeDiv = document.getElementById(id);
      if (!homeDiv?.hasChildNodes()) {
        noticeError(`content-renderer hydration issue from client "${id}"`);
      }
    }

    const nodeCheck = setTimeout(checkForChildNodes, 500);
    return () => clearTimeout(nodeCheck);
  }, []);

  useEffect(() => {
    const homeDiv = document.getElementById(id);
    if (!homeDiv || homeDiv.nodeName.toLowerCase() !== 'div') {
      noticeError(`content-renderer ESI missing from client "${id}"`);
    }
  }, []);

  return null;
}
